module.exports = __webpack_public_path__ + "img/danghui2.0cce998e.png";